var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.clickAdd)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "form-row" }, [
                      _c(
                        "div",
                        { staticClass: "form-group col-md-12" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.dialectValue,
                                              expression: "dialectValue",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            flex: "1",
                                            "min-width": "1px",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.dialectValue = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("請選擇方言")]
                                          ),
                                          _vm._l(
                                            _vm.dialectList,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.Guid,
                                                  domProps: { value: item },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.Name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.otherDialect
                        ? _c(
                            "div",
                            { staticClass: "form-group col-md-12" },
                            [
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value:
                                                  _vm.local.DialectDescription,
                                                expression:
                                                  "local.DialectDescription",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              placeholder: "請填寫方言名稱",
                                            },
                                            domProps: {
                                              value:
                                                _vm.local.DialectDescription,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.local,
                                                  "DialectDescription",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "form-group col-md-12" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-form-label",
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                          attrs: { for: "" },
                                        },
                                        [_vm._v(" 程度 ")]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.local.Degree,
                                              expression: "local.Degree",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            flex: "1",
                                            "min-width": "1px",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.local,
                                                "Degree",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("請選擇")]
                                          ),
                                          _vm._l(
                                            _vm.degreeList,
                                            function (item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.Guid,
                                                  domProps: { value: item },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.Name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "form-row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-sm",
                          staticStyle: {
                            "margin-left": "6px",
                            "margin-right": "10px",
                          },
                          attrs: { type: "button" },
                          on: { click: _vm.clickCancel },
                        },
                        [_vm._v(" 取消 ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "submit" },
                        },
                        [_vm._v("儲存")]
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }